const Constants = {
  systemTypes: {
    pdn: {
      multiPart: 'PDN001',
    },
  },

  groupsDefinitions: {
    pdn: {
      application: 'PneumaticLine',
    },
  },

  partCategories: {
    pdn: {
      actuator: 'PneumaticCylinder',
      actuatorAoM: 'PneumaticCylinderAoM',
    },
  },

  routes: {
    systems: 'systems',
    shortcuts: 'shortcuts',
  },

  shortcuts: {
    pdnManifold: 'new-pdn-manifold',
    pdnApplication: 'new-pdn-application',
    pdnActuator: 'new-pdn-actuator',
    pdnActuatorAoM: 'new-pdn-actuator-aom',
  },

  sessionStorageKeys: {
    autoExecAction: 'autoExecAction',
    addPartDialogSelection: 'addPartDialogSelection',
    autoCreateGroupUniqueName: 'autoCreateGroupUniqueName',
    autoCreatePartCategoryName: 'autoCreatePartCategoryName',
  },

  autoExecActions: {
    showAddPartDialog: 'showAddPartDialog',
    selectManifoldAddPartDialog: 'selectManifoldAddPartDialog',
    selectApplicationAddPartDialog: 'selectApplicationAddPartDialog',
    launchSizingTool: 'launchSizingTool',
  },
};

export default Constants;
